var BlimpExtPhotogalleryV2 = new Class({
	Extends: BlimpExtV2,
	options: {
		gallery_cls: 'w_photogalleryv2',
		width_by_thumbs: 5,
		add_change_mode_options: false,
		data: null
	},

	post_process_build: function(){
		var self = this;

		if(!this.photogallery){
			var opts = this.options;
			var fp_data;
			this.data = this.data || this.options.data;

			if(this._element.getElement('.w_popup').hasClass('floorplan') && this.data.floorplan){
				fp_data = {
					photos: (this.data.floorplan && this.data.floorplan.length > 0)? this.data.floorplan : this.data.photos,
					content: this.data.content
				};
			}

			var _phg = this._element.getElement('.' + opts.gallery_cls);
			this.photogallery = new PagePhotogalleryV2(_phg, {
				data: (fp_data)? fp_data : this.data,
				thumbs_amount: opts.width_by_thumbs,
				add_change_mode_options: opts.add_change_mode_options,
				missing_img : Res_i + '/l/not-found-grey-new-gallery-big-v2-1.png',
				width_image: 728,
				height_image: 490,
				onAddChangeModeOptions: function(){
					self.add_links();
				}
			});

			this.photogallery.popup = this;
		}

		this.parent();

		if(!this.first_load){
			this.set_default_gallery();
		}
		this.copy_contact_link_to_ad_name();

		this.first_load = false;
	},
	copy_contact_link_to_ad_name: function() {
		var _name = this._element.getElement('.w_popup .name');
		var _link = this._element.getElement('.w_popup .box .website a');
		if (_name && _link) {
			var link = _link.clone();
			_name.adopt(link);
			_link.dispose();
		}
	},

	add_links: function(){
		var _link_container = this._element.getElement('.link_container');

		if(!_link_container || !_link_container.hasClass('_for_listing')) return;

		this._mp_link = _link_container.getElement('.map_view');
		this.for_floorplan = this._element.getElement('.w_popup').hasClass('floorplan');

		if(!this._mp_link  && (this.data.photos && this.data.photos.length == 0) || (this.data.floorplan && this.data.floorplan.length == 0)){
			_link_container.dispose();
		} else {
			if(this.data.floorplan && this.data.floorplan.length > 0){
				this._fp_link = new Element('a',{
					'href': '#',
					// 'text': 'View Floorplan',
					'html': '<i class="icon-floorplan big"></i><span class="link-label">View Floorplan</span>',
					'class': 'floorplan ' + (this.for_floorplan? '_active' : '')
				}).inject(_link_container, 'top');
			}

			if(this.data.photos && this.data.photos.length > 0){
				this._pg_link = new Element('a',{
					'href': '#',
					// 'text': 'View Photo Gallery',
					'html': '<i class="fa fa-camera big"></i><span class="link-label">View Photo Gallery</span>',
					'class': 'photogallery ' + (!this.for_floorplan? '_active' : '')
				}).inject(_link_container, 'top');
			}
		}

		this.add_links_functionality();
	},

	add_links_functionality: function(){
		var _fp, _pg, _mp;
	 	this._monitor = this._element.getElement('.photogalleryv2_container');
	 	this.status_view = !this.for_floorplan? 'pg' : 'fp';

		if(this._fp_link){
			var fp_data = {
				photos: this.data.floorplan,
				content: this.data.content
			};

			this._fp_link.addEvent('click', function(e){
				if(e && e.stop) e.stop();

				if(this.status_view == 'fp') return;

				if(this.status_view == 'pg'){
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if(_pg) _pg.dispose();

				if(_mp) _mp.dispose();

				if(!_fp){
					this.initialize_gallery(this._monitor, fp_data)
					_fp = this._monitor.getElement('.w_photogallery');
				}else{
					this._monitor.adopt(_fp);
				}

				if(this._pg_link) this._pg_link.removeClass('_active');

				if(this._mp_link) this._mp_link.removeClass('_active');

				this._fp_link.addClass('_active');
				this.status_view = 'fp';
			}.bind(this));
		}

		if(this._pg_link){
			this._pg_link.addEvent('click', function(e){
				if(e && e.stop) e.stop();

				if(this.status_view == 'pg') return;

				if(this.status_view == 'fp'){
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if(_fp) _fp.dispose();

				if(_mp) _mp.dispose();

				if(!_pg){
					this.initialize_gallery(this._monitor, this.data)
					_pg = this._monitor.getElement('.w_photogallery');
				}else{
					this._monitor.adopt(_pg);
				}

				if(this._fp_link) this._fp_link.removeClass('_active');

				if(this._mp_link) this._mp_link.removeClass('_active');

				this._pg_link.addClass('_active');
				this.status_view = 'pg';
			}.bind(this));
		}

		if(this._mp_link){
			this._mp_link.addEvent('click', function(e){
				if(e && e.stop) e.stop();

				if(this.status_view == 'mp') return;

				if(!_mp){
					if(!_pg && !this.for_floorplan){
				 		_pg = this._monitor.getElement('.w_photogallery');
				 	}
				 	else if(!_fp){
				 		_fp = this._monitor.getElement('.w_photogallery');
				 	}

					_mp = this.initialize_map();
				}
				else{
					this._monitor.adopt(_mp);
				}

				if(_pg) _pg.dispose();

			 	if(_fp) _fp.dispose();

			 	if(this._pg_link) this._pg_link.removeClass('_active');

				if(this._fp_link) this._fp_link.removeClass('_active');

			 	this._mp_link.addClass('_active');
			 	this.status_view = 'mp';

			}.bind(this));
		}
	},

	set_default_gallery: function(){
		if(!this._pg_link && !this._fp_link) return;

		if(this.for_floorplan) {
			this._fp_link.fireEvent('click');
		} else {
			this._pg_link.fireEvent('click');
		}
	},

	initialize_gallery: function(_element, data){
		this.floorplangallery = new PagePhotogalleryV2(_element, {
			data: data,
			thumbs_amount: this.options.width_by_thumbs,
			missing_img : Res_i + '/l/not-found-grey-new-gallery-big-v2-1.png',
			width_image: 728,
			height_image: 490
		});
	},

	initialize_map: function(){
		var self = this;
		var rpc	= this._mp_link.getAttribute('data-rpc-map');
		var _map = new Element('div', {
						'class': 'map_container'
					}).inject(this._monitor);

		self.remote = new Remote({
			rpc: rpc,
			onSuccess: function(){
				var data = this.get_data();

				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});

		return _map;
	},
});
